"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRemaining = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pad = function pad(n) {
  return n.toString().padStart(2, "0");
};

var TimeRemaining = function TimeRemaining(_ref) {
  var currentTime = _ref.currentTime,
      countdownEnd = _ref.countdownEnd,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? "purple100" : _ref$highlight;

  var timeRemaining = _moment.default.duration((0, _moment.default)(countdownEnd).diff((0, _moment.default)(currentTime)));

  return _react.default.createElement(_.Sans, {
    size: "3",
    color: highlight,
    weight: "medium"
  }, Math.floor(timeRemaining.asSeconds()) <= 0 ? "0 days" : _react.default.createElement(_react.default.Fragment, null, timeRemaining.days() > 0 && pad(timeRemaining.days()) + "d ", timeRemaining.hours() > 0 && pad(timeRemaining.hours()) + "h ", timeRemaining.minutes() > 0 && pad(timeRemaining.minutes()) + "m ", pad(timeRemaining.seconds()) + "s"), _react.default.createElement("span", null, " left"));
};

exports.TimeRemaining = TimeRemaining;
TimeRemaining.displayName = "TimeRemaining";
//# sourceMappingURL=TimeRemaining.js.map